function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, "@keyframes a0_t{0%{transform:translate(0,25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(0,18.5px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(0,25px)}}@keyframes a0_h{0%{height:10px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:23px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:10px}}@keyframes a1_t{0%{transform:translate(15px,10px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(15px,23.25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(15px,10px)}}@keyframes a1_h{0%{height:40px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:13.5px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:40px}}@keyframes a2_t{0%{transform:translate(30px,0);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(30px,25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(30px,0)}}@keyframes a2_h{0%{height:60px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:10px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:60px}}@keyframes a3_t{0%{transform:translate(45px,15px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(45px,20px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(45px,15px)}}@keyframes a3_h{0%{height:30px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:20px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:30px}}@keyframes a4_t{0%{transform:translate(60px,25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(60px,10px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(60px,25px)}}@keyframes a4_h{0%{height:10px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:40px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:10px}}@keyframes a5_t{0%{transform:translate(75px,20px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(75px,15px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(75px,20px)}}@keyframes a5_h{0%{height:20px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:30px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:20px}}@keyframes a6_t{0%{transform:translate(90px,10px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(90px,19.125px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(90px,10px)}}@keyframes a6_h{0%{height:40px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:21.75px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:40px}}@keyframes a7_t{0%{transform:translate(105px,20px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(105px,14.25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(105px,20px)}}@keyframes a7_h{0%{height:20px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:31.5px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:20px}}@keyframes a8_t{0%{transform:translate(120px,5px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(120px,20.875px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(120px,5px)}}@keyframes a8_h{0%{height:50px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:18.25px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:50px}}@keyframes a9_t{0%{transform:translate(135px,25px);animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{transform:translate(135px,22.5px);animation-timing-function:cubic-bezier(.77,0,.175,1)}to{transform:translate(135px,25px)}}@keyframes a9_h{0%{height:10px;animation-timing-function:cubic-bezier(.77,0,.175,1)}50%{height:15px;animation-timing-function:cubic-bezier(.77,0,.175,1)}to{height:10px}}");

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 145 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(0 25)",
    style: {
      animation: "1s linear infinite both a0_t,1s linear infinite both a0_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 40,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(15 10)",
    style: {
      animation: "1s linear infinite both a1_t,1s linear infinite both a1_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 60,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(30)",
    style: {
      animation: "1s linear infinite both a2_t,1s linear infinite both a2_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 30,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(45 15)",
    style: {
      animation: "1s linear infinite both a3_t,1s linear infinite both a3_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(60 25)",
    style: {
      animation: "1s linear infinite both a4_t,1s linear infinite both a4_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 20,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(75 20)",
    style: {
      animation: "1s linear infinite both a5_t,1s linear infinite both a5_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 40,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(90 10)",
    style: {
      animation: "1s linear infinite both a6_t,1s linear infinite both a6_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 20,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(105 20)",
    style: {
      animation: "1s linear infinite both a7_t,1s linear infinite both a7_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 50,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(120 5)",
    style: {
      animation: "1s linear infinite both a8_t,1s linear infinite both a8_h"
    }
  }), React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "#6F62FF",
    transform: "translate(135 25)",
    style: {
      animation: "1s linear infinite both a9_t,1s linear infinite both a9_h"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.c2275fa2.svg";
export { ForwardRef as ReactComponent };